
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

// Sample data for the chart
const data = [
  { name: 'Jan', streams: 2500, likes: 1400 },
  { name: 'Feb', streams: 3000, likes: 1600 },
  { name: 'Mar', streams: 3700, likes: 2000 },
  { name: 'Apr', streams: 3500, likes: 1900 },
  { name: 'May', streams: 4000, likes: 2200 },
  { name: 'Jun', streams: 4800, likes: 2500 },
  { name: 'Jul', streams: 6000, likes: 3200 },
  { name: 'Aug', streams: 6493, likes: 3500 },
];

const AnalyticsChart: React.FC = () => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={data}
        margin={{
          top: 5,
          right: 10,
          left: 0,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#333" opacity={0.2} />
        <XAxis 
          dataKey="name" 
          tick={{ fill: '#aaa' }} 
          axisLine={{ stroke: '#444' }} 
        />
        <YAxis 
          tick={{ fill: '#aaa' }} 
          axisLine={{ stroke: '#444' }} 
        />
        <Tooltip 
          contentStyle={{ 
            backgroundColor: '#222', 
            border: '1px solid #444',
            borderRadius: '8px',
            color: '#fff'
          }} 
        />
        <Line 
          type="monotone" 
          dataKey="streams" 
          stroke="#9b87f5" 
          strokeWidth={2}
          dot={{ r: 4, fill: '#9b87f5', strokeWidth: 0 }}
          activeDot={{ r: 6, stroke: '#fff', strokeWidth: 2 }}
        />
        <Line 
          type="monotone" 
          dataKey="likes" 
          stroke="#f97316" 
          strokeWidth={2}
          dot={{ r: 4, fill: '#f97316', strokeWidth: 0 }}
          activeDot={{ r: 6, stroke: '#fff', strokeWidth: 2 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default AnalyticsChart;
